import i18n from 'modules/core/lib/i18n'

import { ResultMatches } from 'modules/payroll_bundle/components/common/helper/worksheet'

export const INITIAL_SELECTION_BUTTON_ID: ImportConfigButtonId = 'name'

export type WorksheetButton = Record<string, string | boolean>

export type WorksheetMatches = Record<string, [number, number, string | number]>

type ImportConfigButtonId =
  | 'name'
  | 'last_name'
  | 'identifier'
  | 'company_identifier'
  | 'net_salary'

type ImportConfigField =
  | 'firstNameCell'
  | 'lastNameCell'
  | 'idCell'
  | 'companyIdentifierCell'
  | 'netSalaryCell'

export interface ImportConfigButton {
  id: ImportConfigButtonId
  order: number
  field: ImportConfigField
  required: boolean
}

const getImportConfigLabel = (id: ImportConfigButtonId) => {
  switch (id) {
    case 'name':
      return i18n.t('payroll_bundle.payroll_results.stage_two.name')
    case 'last_name':
      return i18n.t('payroll_bundle.payroll_results.stage_two.last_name')
    case 'identifier':
      return i18n.t('payroll_bundle.payroll_results.stage_two.document_identifier')
    case 'company_identifier':
      return i18n.t('payroll_bundle.payroll_results.stage_two.company_identifier')
    case 'net_salary':
      return i18n.t('payroll_bundle.payroll_results.stage_two.net_salary')
    default:
      return id
  }
}

export const RESULT_CONFIG_BUTTONS: ImportConfigButton[] = [
  // `field` is the corresponding field name in GraphQL's updatePayrollSummaryImportConfig
  { id: 'name', order: 0, field: 'firstNameCell', required: true },
  { id: 'last_name', order: 1, field: 'lastNameCell', required: true },
  { id: 'net_salary', order: 2, field: 'netSalaryCell', required: true },
  { id: 'identifier', order: 3, field: 'idCell', required: false },
  { id: 'company_identifier', order: 4, field: 'companyIdentifierCell', required: false },
]

export const getRequiredConfigOptions = (importConfigButton: ImportConfigButton[]): string[] => {
  return importConfigButton.filter((button) => button.required).map((button) => button.id)
}

/**
 * It returns a config button compatible with the component WorksheetButton. This data structure is not ideal, but
 * right now it is not possible to refactor the component to use the same data structure as the importConfigButton. ImportConfigButton interface makes much easier
 * to get the required fields, which is necessary to validate the import step 1.
 */
export const convertConfigButtonsToWorksheetButtons = (
  importConfigButtons: ImportConfigButton[]
): WorksheetButton[] => {
  return importConfigButtons.map((button) => ({
    [button.id]: getImportConfigLabel(button.id),
    required: button.required,
  }))
}

export const activeButtonLabel = (activeButton: string) => {
  const button = RESULT_CONFIG_BUTTONS.find((b) => b.id === activeButton)

  if (!button) {
    return
  }
  return getImportConfigLabel(button.id).toLowerCase()
}

export const isButtonRequired = (activeButton: string) => {
  const button = RESULT_CONFIG_BUTTONS.find((b) => b.id === activeButton)

  return button?.required ?? false
}

export const areAllFieldsSelected = (worksheetMatches: ResultMatches) => {
  return RESULT_CONFIG_BUTTONS.every((button) => !!worksheetMatches[button.id])
}
